var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',{staticClass:"box"},[_c('h1',[_vm._v("Trabalho")]),_c('v-divider',{staticClass:"py-3"}),_c('PFCustomerWork',{attrs:{"is-complete-remittance":_vm.isCompleteRemittance},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }